module.exports = __webpack_public_path__ + "static/media/html.e7909a32.svg";